import classNames from 'classnames';
import React from 'react';
var css = {
  "radioBtn": "rui-R8ezr",
  "radio": "rui-oe3eV"
};
var NewRadio = function NewRadio(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    size = _ref.size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onClick = _ref.onClick,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var handleOnClick = function handleOnClick(event) {
    var checked = event.target.checked;
    onClick({
      id: id,
      name: name,
      value: value,
      checked: checked
    });
  };
  var style = {};
  if (typeof size !== 'undefined') {
    style = {
      height: "".concat(size, "px"),
      width: "".concat(size, "px")
    };
  }
  return /*#__PURE__*/React.createElement("input", {
    id: id,
    name: name,
    style: style,
    type: "radio",
    value: value,
    onClick: handleOnClick,
    className: classNames(css.radioBtn, className),
    checked: !!checked,
    disabled: !!disabled
  });
};
export default NewRadio;